
import {deep_copy, deep_assign, deep_array_return} from "../../lib/js-utils";
import superagent from "superagent";
import {authorize} from "../helper/authorize-token";
import {sprintf} from "sprintf-js";
import {string_cmp} from "../../lib/js-utils";

const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
const LOAD_QUEUE_ITEMS = "LOAD_QUEUE_ITEMS";
const LOAD_USER_NOTIFICATIONS = "LOAD_USER_NOTIFICATIONS";
const LOAD_USER_REBALANCE_ITEMS = "LOAD_USER_REBALANCE_ITEMS";
const LOAD_USER_QUEUE_ITEMS = "LOAD_USER_QUEUE_ITEMS";
const SET_NOTIFICATIONS_LOADING = "SET_NOTIFICATIONS_LOADING";
const CREATE_USER_REBALANCE = "CREATE_USER_REBALANCE";
const SET_USER_REBALANCE = "SET_USER_REBALANCE";


const createUserRebalance = (
  username, index, current_risk, new_risk, op, category_allocation,
  security_allocation, trade_orders, portfolio_usd, cash_usd) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: CREATE_USER_REBALANCE,
      payload: superagent
        .post("/api/dashboard/admin-create-rebalance")
        .send({ username, index, current_risk, new_risk, op,
          category_allocation, security_allocation, trade_orders, portfolio_usd,
          cash_usd})
        .use(authorize(getState()))
    });
  }
}

const setUserRebalance = (username, index, queue_item, category_to_etf, etf_to_category) => {
  return dispatch => {
    dispatch({
      type: SET_USER_REBALANCE,
      username,
      index,
      queue_item,
      category_to_etf,
      etf_to_category,
    })
  }
}
const loadNotifications = (notification_types) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: LOAD_NOTIFICATIONS,
      payload: superagent
        .post("/api/dashboard/admin-load-notifications")
        .send({notification_types})
        .use(authorize(getState()))
    })
  }
}

const loadQueueItems = (queue_types) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: LOAD_QUEUE_ITEMS,
      payload: superagent
        .post("/api/dashboard/admin-load-queue-items")
        .send({queue_types})
        .use(authorize(getState()))
    });
  }
}

const loadUserNotifications = (username, index, notification_type) => {
  return (dispatch, getState) => {
    const notif_store = getState().notification;
    if (notif_store[username] && notif_store[username][index]) {
      return;
    }
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: LOAD_USER_NOTIFICATIONS,
      payload: superagent
        .post("/api/dashboard/admin-user-notifications")
        .send({username, index, notification_type})
        .use(authorize(getState()))
    })
  }
}

/*const loadUserRebalanceItems = (username, index) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: LOAD_USER_REBALANCE_ITEMS,
      payload: superagent
        .post("/api/dashboard/admin-get-user-rebalance-items")
        .send({username, index})
        .use(authorize(getState()))
    })
  }
}*/

const loadUserQueueItems = (username, index, queue_type) => {
  return (dispatch, getState) => {
    const notif_store = getState().notification;
    if (notif_store[username] && notif_store[username][index]) {
      return;
    }
    dispatch({
      type: SET_NOTIFICATIONS_LOADING,
      loading: true,
    });
    dispatch({
      type: LOAD_USER_QUEUE_ITEMS,
      payload: superagent
        .post("/api/dashboard/admin-user-queue-items")
        .send({username, index, queue_type})
        .use(authorize(getState()))
    })
  }
}

const calc_span_data = (user_notifs) => {

  const span_data = [
    ...user_notifs.closed_notifs.map(notif => {
      return {
        from_date: notif.initial_request,
        to_date: notif.executed,
        color: "rgba(0, 200, 0, 0.4)",
        selected_color: "rgba(0, 255, 0, 0.4)",
        selected_outline: "rgba(0, 255, 0, 0.8)",
        label: sprintf("Executed %s", notif.id),
        data: notif.id,
      }
    }),
    ...user_notifs.canceled_notifs.map(notif => {
      return {
        from_date: notif.initial_request,
        to_date: notif.portfolio_date,
        color: "rgba(0, 200, 0, 0.1)",
        selected_color: "rgba(0, 255, 0, 0.1)",
        selected_outline: "rgba(0, 255, 0, 0.4)",
        label: sprintf("Canceled %s", notif.id),
        data: notif.id,
      }
    })
  ];

  if (user_notifs.current_notif) {
    const notif = user_notifs.current_notif;
    span_data.push({
      from_date: notif.initial_request,
        to_date: notif.portfolio_date,
      color: "rgba(0,200,0,0.2)",
      label: sprintf("Current %s", notif.id),
      data: notif.id,
    });
  }

  return span_data;
}

const calc_span_data_queue = (queue_items) => {

  const span_data = [
    ...queue_items.closed_items.map(items => {
      return {
        from_date: items.opened_date,
        to_date: items.closed_date,
        color: "rgba(0, 200, 0, 0.4)",
        selected_color: "rgba(0, 255, 0, 0.4)",
        selected_outline: "rgba(0, 255, 0, 0.8)",
        label: sprintf("Rebalance %s", items.id),
        data: items.id,
      }
    }),
    ...queue_items.canceled_items.map(item => {
      return {
        from_date: item.opened_date,
        to_date: item.closed_date,
        color: "rgba(0, 200, 0, 0.1)",
        selected_color: "rgba(0, 255, 0, 0.1)",
        selected_outline: "rgba(0, 255, 0, 0.4)",
        label: sprintf("Rebalance %s", item.id),
        data: item.id,
      }
    }),
    ...queue_items.current_items.map(item => {
      return {
        from_date: item.opened_date,
        to_date: item.current_date,
        color: "rgba(0,200,0,0.2)",
        label: sprintf("Rebalance %s", item.id),
        data: item.id,
      }
    })
  ];

  return span_data;
}


const download_rebalance_csv = (token, rebalance_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/get-rebalance-csv")
      .use(authorize(token))
      .send({rebalance_id})
      .then(res => {
        return resolve(res.body.data.csv);
      })
  })
}

const ZERO_STATE = {
  loading: false,
  executed: [],
  queued: [],
  user: {},
}

const replace = (arr_ref, item) => {
  let index = -1;
  arr_ref.arr.forEach((curr_item, curr_index) => {
    if (curr_item.id === item.id) {
      index = curr_index;
    }
  });
  if (index === -1) {
    // array is empty, add the item
    arr_ref.arr.push(item);
  } else {
    // Replace the item
    arr_ref.arr[index] = item;
  }
  arr_ref.arr.sort((a, b) => string_cmp(a.id, b.id));
}

const replace_items = (arr, items) => {
  items.forEach(item => {
    replace({ arr }, item);
  })
}

const adminNotificationReducer = (state = ZERO_STATE, action) => {

  let new_state = deep_copy(state);
  let response, username, index;

  switch(action.type) {
    case SET_NOTIFICATIONS_LOADING:
      new_state.loading = action.loading;
      break;
    case LOAD_NOTIFICATIONS + "_FULFILLED":
      response = action.payload.body.data;
      new_state.loading = false;
      new_state.queued = response.queued;
      new_state.executed = response.executed;
      new_state.category_to_etf = response.category_to_etf;
      new_state.etf_to_category = response.etf_to_category;
      break;
    case LOAD_QUEUE_ITEMS + "_FULFILLED":
      response = action.payload.body.data;
      new_state.loading = false;
      new_state.queued = response.queued;
      new_state.executed = response.executed;
      new_state.category_to_etf = response.category_to_etf;
      new_state.etf_to_category = response.etf_to_category;
      break;

    case LOAD_USER_REBALANCE_ITEMS + "_FULFILLED":
      new_state.loading = false;
      const data = action.payload.body.payload;
      username = data.username;
      index = data.index;
      deep_assign(new_state, [username, index], {
        closed_notifs: data.closed_items,
        canceled_notifs: data.canceled_items,
        current_notifs: data.current_items,
        span_data: calc_span_data_queue(data),
      });
      break;
    case CREATE_USER_REBALANCE + "_FULFILLED":
      response = action.payload.body.payload;
      username = response.username;
      index = response.index;
      replace(
        deep_array_return(new_state, [username, index, 'current_notifs'], []),
        response.item);
      replace(
        { arr: new_state.queued }, response.item);
      new_state.loading = false;
      new_state.category_to_etf = response.category_to_etf;
      new_state.etf_to_category = response.etf_to_category;
      break;

    case SET_USER_REBALANCE:
      replace(
        deep_array_return(new_state, [action.username, action.index, 'current_notifs'], []),
        action.queue_item);
      replace({ arr: new_state.queued }, action.queue_item);
      new_state.category_to_etf = action.category_to_etf;
      new_state.etf_to_category = action.etf_to_category;
      break;
    case LOAD_USER_NOTIFICATIONS + "_FULFILLED":
      response = action.payload.body.data;
      username = response.username;
      index = response.index;
      new_state.loading = false;
      deep_assign(new_state, [username, index], {
        closed_notifs: response.closed_notifs,
        canceled_notifs: response.canceled_notifs,
        current_notif: response.current_notif,
        span_data: calc_span_data(response),
      })
      break;
    case LOAD_USER_QUEUE_ITEMS + "_FULFILLED":
      response = action.payload.body.data;
      username = response.username;
      index = response.index;
      replace_items(new_state.executed, response.closed_items);
      replace_items(new_state.queued, response.current_items);
      new_state.loading = false;
      new_state.category_to_etf = response.category_to_etf;
      new_state.etf_to_category = response.etf_to_category;
      deep_assign(new_state, [username, index], {
        closed_notifs: response.closed_items,
        canceled_notifs: response.canceled_items,
        current_notifs: response.current_items,
        span_data: calc_span_data_queue(response),
      })
      break;
    default:
      break;
  }

  return new_state;
}

export {
  adminNotificationReducer, loadNotifications, download_rebalance_csv,
  loadUserNotifications, loadQueueItems, loadUserQueueItems,
  createUserRebalance, setUserRebalance,
};
